import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminCheckSession, adminLogin } from "./adminApi";
import "./AdminDashboard.css";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [checkingSession, setCheckingSession] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;

    async function checkExistingSession() {
      try {
        const data = await adminCheckSession();
        if (mounted && data?.authenticated === true) {
          navigate("/admin", { replace: true });
        } else if (mounted) {
          setCheckingSession(false);
        }
      } catch (_) {
        if (mounted) {
          setCheckingSession(false);
        }
      }
    }

    checkExistingSession();

    return () => {
      mounted = false;
    };
  }, [navigate]);

  async function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    setError("");

    try {
      await adminLogin(email.trim(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err.message || "Admin login failed.");
    } finally {
      setLoading(false);
    }
  }

  if (checkingSession) {
    return <div className="admin-login-shell">Loading...</div>;
  }

  return (
    <div className="admin-login-shell">
      <div className="admin-card admin-login-card">
        <h2 className="admin-section-title">Admin Dashboard Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="admin-form-row">
            <label>Email</label>
            <input
              className="admin-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
            />
          </div>

          <div className="admin-form-row">
            <label>Password</label>
            <input
              className="admin-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          {error && <div className="admin-error">{error}</div>}

          <div className="admin-button-row" style={{ marginTop: 12 }}>
            <button
              className="admin-button admin-button-primary"
              type="submit"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
